/**
 *
 * @author: Huning
 * @date: 2019-07-03
 *
 */
import React, { PureComponent, Fragment } from 'react'
import { connect } from 'react-redux'
import { Link, withRouter } from 'react-router-dom'
import { Menu, Icon } from 'antd'
import routerConfig from '@/routes/routesConfig'

const { SubMenu, ItemGroup } = Menu
@connect(state => {
  return {
    router: state.get('router')
  }
})
@withRouter
class BasicMenu extends PureComponent {
  render() {
    const { state, props } = this
    const { router } = props
    const selectedKeys = router.getIn(['location', 'pathname'])
    const TitleRender = ({ name, icon, path }) => {
      let RealIcon = null
      if (icon && typeof icon === 'string') {
        RealIcon = () => <Icon type={icon} />
      }
      if (icon && typeof icon === 'object' && icon.type) {
        RealIcon = () => <Icon type={icon.type} theme={icon.theme} />
      }
      if (path) {
        return (
          <Link to={path}>
            {RealIcon ? <RealIcon /> : ''}
            <span>{name}</span>
          </Link>
        )
      }
      return (
        <span>
          {RealIcon ? <RealIcon /> : ''}
          <span>{name}</span>
        </span>
      )
    }
    const MenuSub = ({ children, name, path, icon, hideInMenu }, index) => {
      if (hideInMenu) return ''
      if (icon && children && children.length > 0) {
        return (
          <SubMenu key={`sub${index}`} title={<TitleRender {...{ name, icon, path }} />}>
            {children.map(MenuSub)}
          </SubMenu>
        )
      }
      if (!icon && children && children.length > 0) {
        return (
          <ItemGroup key={name} title={name}>
            {children.map(MenuSub)}
          </ItemGroup>
        )
      }
      return (
        <Menu.Item key={path}>
          <TitleRender {...{ name, icon, path }} />
        </Menu.Item>
      )
    }
    return (
      <Fragment>
        <Menu
          mode="vertical"
          theme="dark"
          style={{ borderRight: 0 }}
          defaultSelectedKeys={[selectedKeys]}
          selectedKeys={[selectedKeys]}
        >
          {routerConfig.map(MenuSub)}
        </Menu>
      </Fragment>
    )
  }
}

export default BasicMenu
